import { render, staticRenderFns } from "./LabelWithEditIconAndContent.vue?vue&type=template&id=30e8c5c8&"
import script from "./LabelWithEditIconAndContent.vue?vue&type=script&lang=js&"
export * from "./LabelWithEditIconAndContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports